import React from 'react';
import axios from 'axios';
import { motion } from 'framer-motion';

import { useModal } from '../Components/Modal/ModalContext';

import Loading from '../Components/Loading';

import HeaderPanel from '../Components/HeaderPanel';
import CardOfCase from '../Components/CardOfCase';

const Favorites = () => {
    const { openModal } = useModal();
    const [cases, setCases] = React.useState([]);
    const [warning, setWarning] = React.useState('');
    const [loading, setLoading] = React.useState(true);
    const [reload, setReload] = React.useState(true);

    const [idCaseForModal, setIdCaseForModal] = React.useState('');
    const [IsModal, setIsModal] = React.useState(false);
    const closeModal = () => setIsModal(false);

    React.useEffect(() => {
      const token = localStorage.getItem('token');

      axios.get('/api/cases-for-AM-favorites', {
        headers: {
            Authorization: `Bearer ${token}`,
        }
      })
      .then(response => {
          if (response.data.length === 0) {
            setWarning('На данный момент вы не закрепили ни одного дела в избранные.');
          } else {
            setWarning('');
            setCases(response.data);
          }
      })
      .catch(error => {
        setWarning(`Ошибка при загрузке таблицы избранных дел: ${error.response?.data.message || error.message}`);
      })
      .finally(() => {
        setLoading(false);
        setReload(false);
      })
    }, [reload]);

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}.${month}.${year}`;
    };
    const formatComment = (comment) => {
      if (comment === 'Заметка отсутствует') {
          return <span style={{color: 'rgb(169, 169, 169)'}}>{comment}</span>
      }else {
          const truncatedComment = comment.length > 120 ? comment.substring(0, 120) + '...' : comment;
          return <span>{truncatedComment}</span>;
      }
    };

    return (
      <>
        {IsModal && <CardOfCase closeModal={closeModal} id={idCaseForModal} onCardOfCaseSuccess={() => {setReload(true)}} />}

        <div className='mainContainer'>
        <h1>Избранное</h1>
        <HeaderPanel typePanel='Арбитражный управляющий' />
        {/* <div className={headerPanel.additionalPanel}>
          <input type='text' placeholder='Поиск по номеру...' />
        </div> */}
        <div className='table-container'>
          <div className='tableHeader'>
              <a className='numberCase'>Номер</a>
              <a className='categoryCase'>Этап</a>
              <a className='applicantCase'>Истец</a>
              <a className='commentsCase'>Заметка</a>
              <a className='datesCase'>Начальная дата / Конечная дата</a>
              <a className='statusCase'>Статус</a>
          </div>
          <motion.div
              initial={{ scale: '97%', opacity: 0 }}
              animate={{ scale: '100%', opacity: 1 }}
              exit={{ scale: '97%', opacity: 0 }}
              transition={{ duration: 0.3 }}
          >
            {loading && <Loading />}
            {warning && <div className='case warningLine'><a>{warning}</a></div>}
            {cases.map((cases) => (
                <div className='case' key={cases.id} onClick={() => {setIsModal(true); setIdCaseForModal(cases.id)}}>
                    <a className='numberCase'>{cases.number}</a>
                    <a className='categoryCase'>{cases.nameCategory}</a>
                    <a className='applicantCase'>{cases.applicant}</a>
                    <a className='commentsCase'>{formatComment(cases.comments)}</a>
                    <a className='datesCase'>{formatDate(cases.date_start)} / {formatDate(cases.date_end)}</a>
                    <a className='statusCase' style={{borderBottom: 'none', borderRight: 'none'}}>{cases.status}</a>
                </div>
            ))}
          </motion.div>
          </div>
        </div>
      </>
    )
}

export default Favorites;